import { render, staticRenderFns } from "./AppContentEditor.vue?vue&type=template&id=b1fd878e&scoped=true"
import script from "./AppContentEditor.vue?vue&type=script&lang=js"
export * from "./AppContentEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1fd878e",
  null
  
)

export default component.exports